// import type
import { SET_CLIENTSTATUS_LIST } from './type'

export const clientList = (data, dispatch) => {
  dispatch({
    type: SET_CLIENTSTATUS_LIST,
    clientList: {
      list: data?.list,
    },
  })
}
